"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommissionWording = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var portal_core_1 = require("@ferry/portal-core");
var CommissionWording = /** @class */ (function (_super) {
    __extends(CommissionWording, _super);
    function CommissionWording(props) {
        return _super.call(this, props) || this;
    }
    CommissionWording.prototype.render = function () {
        var brandName = (0, portal_core_1.getPrettifiedInteractionBrandName)(this.props.interaction.brandName);
        return ((0, jsx_runtime_1.jsxs)("p", { className: "mb-4", children: ["Volkswagen Financial Services (UK) Ltd is an introducer to ", brandName, " Car Insurance, underwritten by Liverpool Victoria Insurance Company Limited, and gets paid a commission for this. ", (0, jsx_runtime_1.jsx)("br", {}), "Please contact us for further details of this commission arrangement."] }));
    };
    return CommissionWording;
}(plugin_journey_1.WidgetBase));
exports.CommissionWording = CommissionWording;
//# sourceMappingURL=CommissionWording.js.map